import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex h-screen justify-center items-center">
      <vs-icon name="loading-02" class="text-primary-500 animate-spin" size="80"></vs-icon>
    </div>
  `,
  standalone: false,
})
export class RefreshPage {}
